import * as React from "react";
type Props = {
  className?: string,
};
function SvgX({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-x"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6568 4.92892L19.0711 6.34314L13.4139 11.9999L19.0711 17.6568L17.6568 19.0711L11.9999 13.4139L6.34314 19.0711L4.92892 17.6568L10.5849 11.9999L4.92892 6.34314L6.34314 4.92892L11.9999 10.5849L17.6568 4.92892Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgX;
